import { OtpGenerateUseCase } from '../../../application';

export default class OtpGenerateService {
    constructor() {}

    async execute(event) {
        const request = await OtpGenerateUseCase(event);

        return request;
    }
}
